import './IndicatorsTabComponent.scss';

const IndicatorsTabComponent = ({ symbol }) => {
  return (
    <div className="indicators-tab">indicators content goes here for {symbol}.</div>
  );
};

export default IndicatorsTabComponent;